import { Select } from '@navikt/ds-react'
import styled from 'styled-components'
import { Widget, WidgetProps } from 'index.d'
import { WidgetPropType } from 'index.pt'
import NodeWidget from './NoteWidget'
import _ from 'lodash'
import PT from 'prop-types'
import React, { useState } from 'react'

const NoteOptionsDiv = styled.div`
  padding: 1rem;
`

const NoteOptionsWidget: React.FC<WidgetProps> = ({ onUpdate, widget }: WidgetProps): JSX.Element => {
  const [backgroundColor, setBackgroundColor] = useState<string>(widget!.options.backgroundColor)

  const chooseColor = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const color: string = e.target.value
    const newWidget: Widget = _.cloneDeep(widget!)
    newWidget.options.backgroundColor = color
    setBackgroundColor(color)
    onUpdate(newWidget)
  }

  return (
    <NoteOptionsDiv className='w-NoteOptionsWidget'>
      <Select
        size='small'
        id='w-NoteOptionsWidget__color-select-id'
        label='color'
        value={backgroundColor || ''}
        onChange={chooseColor}
      >
        {NodeWidget.properties.options.availableColors.map((color: string) => {
          return <option key={color} value={color}>{color}</option>
        })}
      </Select>
    </NoteOptionsDiv>
  )
}

NoteOptionsWidget.propTypes = {
  onUpdate: PT.func.isRequired,
  widget: WidgetPropType.isRequired
}

export default NoteOptionsWidget
